import { CSSProperties, ReactNode } from 'react';
import { FieldError } from 'react-hook-form';
import { InputError } from './InputError';
import { LabelFor } from './LabelFor';
import { cx } from '#/Scripts/utilities/cx';

type InputWrapperProps = {
  name: string;
  label: string;
  error?: FieldError;
  className?: string;
  style?: CSSProperties;
  fieldType: string;
  children: ReactNode;
  icon?: ReactNode;
};

export const InputWrapper = ({ name, label, error, fieldType, className, style, children, icon }: InputWrapperProps) => {

  return (
    <div className={cx('form-input', error?.message && 'error', className)} style={style}>
      <div className={`basic-field ${fieldType}`}>
        <div className="field-group">
          {children}
          {icon}
        </div>
      </div>
      <LabelFor name={name} label={label} />
      <InputError error={error} name={name} />
    </div>
  );
};

export default InputWrapper;
